import React from 'react';
import logoDark from '../../assets/img/logo/lalliance-dark.png';
import logoAlt from '../../assets/img/logo/lalliance-alt.png';
import classnames from 'classnames';
import logoStyles from './Logo.module.css';

// logoStyle: 'white' = lalliance-alt (dark surfaces), 'black' = lalliance-dark (light surfaces)
export function Logo({ logoStyle = 'white', height, className, ...rest }) {
  const onDarkBg = logoStyle === 'white';

  return (
    <div
      className={classnames(logoStyles.logo, className)}
      style={height ? { height } : undefined}
      {...rest}
    >
      <span className={logoStyles.logo__stack}>
        <img
          className={classnames(logoStyles.logo__layer, {
            [logoStyles['logo__layer--visible']]: onDarkBg,
          })}
          src={logoAlt}
          alt=""
          aria-hidden="true"
          decoding="async"
        />
        <img
          className={classnames(logoStyles.logo__layer, {
            [logoStyles['logo__layer--visible']]: !onDarkBg,
          })}
          src={logoDark}
          alt=""
          aria-hidden="true"
          decoding="async"
        />
      </span>
      <span className={logoStyles.logo__label}>L&apos;alliance Rent a Car</span>
    </div>
  );
}
